import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api/menuitem';
import { DownloadService } from 'src/app/services/download.service';
import { OrderService } from 'src/app/services/order.service';
import { saveAs } from 'file-saver';
import { Order } from 'src/app/intefaces/order';
import { paymentTypeEnum } from 'src/app/intefaces/orderManagementFrame';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { CurrencyPipe } from '@angular/common';
import { CurrencyFormaterPipe } from 'src/app/pipes/currencyReduce.pipe';
import { ActivatedRoute, Route } from '@angular/router';
import { Router } from '@angular/router';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-my-orders',
    templateUrl: './myOrders.component.html',
    styleUrls: ['./myOrders.component.scss']
})
export class MyOrdersComponent implements OnInit {

    constructor(private browserStorageService: BrowserStorageService, private download: DownloadService, private translate: TranslateService, private orderService: OrderService, private pageService: InformationPageService, private currencyPipe: CurrencyPipe,
        private currencyFormaterPipe: CurrencyFormaterPipe, private route: ActivatedRoute, private router: Router, private alertService: HttpAlertService, private title: Title) {

        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.id = params['id'];
        });
    }

    items: MenuItem[];
    itemsNote: MenuItem[];
    selectedOption;
    isDataReady = false;
    displayBankTransferInfo = false;
    public id = null;
    slug = null;
    frame = {
        page: 0,
        orderId: null
    }
    paymentInProgress = false;
    public myOrders: Order[] = [];
    interval = null;

    ngOnInit(): void {
        this.initMenu();
        this.translate.onLangChange.subscribe(lang => {
            this.initMenu();
        });

        if (this.id != null && this.slug == 'success') {
            this.frame.orderId = this.id;
            this.paymentInProgress = true;
            this.getMyOrders();
            this.interval = setInterval(() => {
                this.getMyOrders();
            }, 5000);
        } else {
            this.getMyOrders();
        }
        this.translate.get('title_my_orders').subscribe({
            next: (title) => {
                this.title.setTitle(title);
            }
        });
    }

    public limit = 0;
    public totalRows = 0;
    private getMyOrders() {
        this.orderService.myOrders(this.frame).subscribe(data => {
            this.limit = data.data.per_page;
            this.totalRows = data.data.total;
            this.myOrders = data.data.data;
            this.isDataReady = true;
            if (this.id != null && this.slug == 'pay') {
                this.onCreatePayment(data.data.data.find(x => x.id == this.id));
            }
            if (this.id != null && this.slug == 'success') {
                if (this.paymentInProgress) {
                    const index = this.myOrders.findIndex(x => x.id == this.id);
                    if (this.myOrders[index].is_paid) {
                        this.paymentInProgress = false;
                        if (this.interval) clearInterval(this.interval);
                        this.alertService.success('order_paid');
                    }
                }

            }

        })
    }

    ngOnDestroy(): void {
        if (this.interval) clearInterval(this.interval);
    }

    private initMenu() {
        this.translate.get(['download_invoice', 'download_note']).subscribe(t => {
        });
        this.translate.get(['download_invoice', 'download_note']).subscribe(t => {
            setTimeout(() => {
                this.items = [
                    { id: "0", label: t.download_invoice, icon: '<i class="pi pi-fw pi-download"></i>' }
                ];
                this.itemsNote = [
                    { id: "0", label: t.download_note, icon: '<i class="pi pi-fw pi-download"></i>' }
                ];
            }, 100);
        });
    }

    public bankInfo: Order = null;
    public infoBank = '';
    public onCreatePayment(order: Order) {
        order.isPayInProgress = true;

        if (order.payment_type == paymentTypeEnum.NORMAL) {
            this.openTransferInfo(order);
        } else if (order.payment_type == paymentTypeEnum.PREPAID) {
            this.openPrepaidInformation(order);
        } else {
            this.onlinePay(order);
        }
    }

    private openPrepaidInformation(order) {
        order.isPayInProgress = false;
        this.onlinePay(order);
    }

    private openTransferInfo(order) {
        this.displayBankTransferInfo = true;
        this.bankInfo = order;

        this.pageService.getInformationPage(this.pageService.PAGES.INFO_BANK_TRANSFER, this.browserStorageService.get("_lang")).subscribe((response: any) => {
            this.infoBank = response.data.page[Object.keys(response.data.page)[0]];
            let totalAmount = 0;
            order.items.forEach(d => {
                totalAmount += d.price;
            });

            totalAmount = this.currencyFormaterPipe.transform(totalAmount, true, order.currency_histories.exchange_rate);
            const totalAmount_a = this.currencyPipe.transform(totalAmount, order.currency_histories.currency.currency_code);

            this.infoBank = this.infoBank.replace("{NO}", order.id.toString());
            this.infoBank = this.infoBank.replace("{PRICE}", totalAmount_a);
            order.isPayInProgress = false;
        });
    }

    public onPaginate(ev) {
        this.frame.page = ev.page + 1;
        this.getMyOrders();
    }

    public onDownloadInvoice(order) {
        this.download.downloadInvoice(order.invoice).subscribe(data => {
            saveAs(data, 'invoice-no-' + order.invoice.invoice_number + '.pdf');
        });
    }

    public hasAvailableInvoice(order: Order): boolean {
        return !!(order?.manual_invoice || (order?.is_created_invoice && order?.invoice));
    }

    public onDownloadAvailableInvoice(order: Order) {
        if (order?.manual_invoice) {
            this.download.downloadManualInvoice(order.manual_invoice).subscribe(data => {
                saveAs(data, order.manual_invoice.original_name);
            });
            return;
        }

        if (order?.invoice) {
            this.onDownloadInvoice(order);
        }
    }

    private onlinePay(order) {
        this.orderService.createPaymentPayU(order).subscribe(data => {
            order.isPayInProgress = false;
            if (data.data && data.data.url) {
                window.location.href = data.data.url;
            } else {
                if (data.data == 'ok') {
                    window.location.reload();
                } else {
                    this.router.navigate(['/my-account/prepaid-account']);
                }

            }

        }, err => order.isPayInProgress = false);
    }

    public onDownloadFile(note) {
        note.isDownloading = true;
        this.download.downloadNote(note).subscribe(response => {
            note.isDownloading = false;
            saveAs(response, note.filename);
        },
            err => note.isDownloading = false);
    }

}
